import { AppRoute } from 'common/routing/app-route';
import * as Admin from './admin';
import * as Company from './company';
import * as Subscription from './own-company-subscription';

const planExpired = new AppRoute('/plan-expired');
const products = new AppRoute('/products');
const emptyAccount = new AppRoute('/empty-account');

const accountManage = new AppRoute('/account/manage');

export const AppUrls = {
  account: {
    manage: accountManage,
  },
  admin: Admin.Urls,
  subscription: Subscription.Urls,
  company: Company.Urls,
  planExpired,
  products,
  emptyAccount,
};
